export default ` 
    <div id="#= data.containerId #" class="#= data.containerClasses || "" # #=data.bsc||""#">
        <div id="#= data.id #_Overlay" class="picture-overlay #: data.pictureClasses || "" #">
            <div class="overlay-message">
                <i class="#: data.overlayIconClasses #"></i><br/>
                <div> 
                    #: z.ll(data.overlayMessage) #
                </div>
            </div>
        </div>
        <div id="#= data.id #" class="picture #: data.pictureClasses || "" #"></div>
    </div>
`;
